import css from 'styled-jsx/css';

export default css`
  .SitePostActions__action {
    margin: 0 0.25rem;
    font-size: 1rem;
  }
`;
